<template lang="pug">
.preview-iphone-email-navbar.d-flex.justify-space-between
  v-icon(size="16" color="basic700") mdi-arrow-left
  div.d-flex
    v-icon.mx-2(size="16" color="basic700") mdi-package-down
    v-icon.mx-2(size="16" color="basic700") mdi-trash-can-outline
    v-icon.mx-2(size="16" color="basic700") mdi-email-outline
    v-icon.ml-1(size="16" color="basic700") mdi-dots-vertical
</template>

<script>
export default {
  name: 'PreviewIphoneEmailNavbar'
}
</script>

<style scoped>
</style>